export const PLAYIT_API_SSL_BASE = "https://apissl.playit.mobi";

export function isZainIqGamezroidHost(hostname = window.location.hostname) {
  return (
    hostname === "z-iq.gamezroid.com" || hostname === "www.z-iq.gamezroid.com"
  );
}

export function getPlayitApiV2Base() {
  if (isZainIqGamezroidHost()) {
    return `${PLAYIT_API_SSL_BASE}/api/v2`;
  }

  return "https://apissl.playit.mobi/api/v2";
}

export function resolvePlayitApiUrl(url) {
  if (!url || typeof url !== "string" || !isZainIqGamezroidHost()) {
    return url;
  }

  return url
    .replace(/^https?:\/\/www\.api\.playit\.mobi/i, PLAYIT_API_SSL_BASE)
    .replace(/^https?:\/\/api\.playit\.mobi/i, PLAYIT_API_SSL_BASE);
}
